import { Navigate } from 'react-router-dom';

import { LANDING } from '@sorare/core/src/constants/__generated__/routes';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import {
  WalletTab,
  useWalletDrawerContext,
} from '@sorare/core/src/contexts/walletDrawer';
import { useIsMobileApp } from '@sorare/core/src/hooks/useIsMobileApp';

const WalletPage = () => {
  const { isIosApp } = useIsMobileApp();
  const { currentUser } = useCurrentUserContext();
  const { showDrawer, setCurrentTab, drawerOpened } = useWalletDrawerContext();

  if (!currentUser || !isIosApp) {
    return <Navigate to={LANDING} />;
  }

  if (!drawerOpened) {
    showDrawer();
    setCurrentTab(WalletTab.HOME);
  }

  return null;
};

export default WalletPage;
